/* eslint-disable */
import React, { MutableRefObject, useEffect } from "react";
import renderMathInElement from "katex/dist/contrib/auto-render";

export const useKatex = (element: MutableRefObject<HTMLDivElement | null>, dependencies: any[] = []) => {
	useEffect(() => {
		if (element.current != null) {
			renderMathInElement(element.current, {
				delimiters: [
					{ left: "$$", right: "$$", display: true },
					{ left: "\\(", right: "\\)", display: false },
					{ left: "\\[", right: "\\]", display: true },
					{ left: "$", right: "$", display: false },
				],
			});
		}
	}, dependencies);
};
